/**
 * @method areSetsEqual
 * prevSet, nextSet: sets for comparing if equeal
 */
const areSetsEqual = (prevSet, nextSet) =>
  prevSet.size === nextSet.size && [...nextSet].every((i) => prevSet.has(i));

export default areSetsEqual;
